module.exports = __webpack_public_path__ + "img/certificate-1-4.e4b99209.jpg";